import React from 'react';
import { GraduationCap, Users, Target, FileText, Briefcase, MessageSquare } from 'lucide-react';

const TemplateCategories = () => {
  const categories = [
    {
      icon: GraduationCap,
      title: 'Training Programs',
      description: 'Pre-built training curriculums for onboarding, sales, support, and more',
      count: '150+',
      color: 'blue'
    },
    {
      icon: Target,
      title: 'Roleplay Scenarios',
      description: 'Practice scenarios for objection handling, discovery calls, and customer situations',
      count: '175+',
      color: 'indigo'
    },
    {
      icon: FileText,
      title: 'SOPs & Processes',
      description: 'Standard operating procedures for every department',
      count: '200+',
      color: 'green'
    },
    {
      icon: Briefcase,
      title: 'Roles & Responsibilities',
      description: 'Job descriptions and accountability charts for key positions',
      count: '125+',
      color: 'orange'
    },
    {
      icon: MessageSquare,
      title: 'Communication Scripts',
      description: 'Structured conversation guides and AI-powered coaching frameworks',
      count: '160+',
      color: 'cyan'
    },
    {
      icon: Users,
      title: 'Team Development',
      description: 'Leadership training, team building, and performance coaching templates',
      count: '140+',
      color: 'purple'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-900/30 border-blue-700 text-blue-400',
    indigo: 'bg-indigo-900/30 border-indigo-700 text-indigo-400',
    purple: 'bg-purple-900/30 border-purple-700 text-purple-400',
    green: 'bg-green-900/30 border-green-700 text-green-400',
    orange: 'bg-orange-900/30 border-orange-700 text-orange-400',
    cyan: 'bg-cyan-900/30 border-cyan-700 text-cyan-400'
  };

  return (
    <section className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Browse by Category</h2>
          <p className="text-xl text-gray-400">Find the perfect template for your needs and customize it with Traain</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-2xl p-8 border border-gray-800"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 border ${colorClasses[category.color]}`}>
                <category.icon className="w-7 h-7" />
              </div>
              
              <div className="flex items-start justify-between mb-4">
                <h3 className="text-xl font-bold text-white">
                  {category.title}
                </h3>
                <span className="px-3 py-1 bg-gray-800 border border-gray-700 rounded-full text-sm text-gray-300">
                  {category.count}
                </span>
              </div>
              
              <p className="text-gray-400 text-sm">
                {category.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TemplateCategories;